/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  Container,
  Form,
  Header,
  Icon,
  Label,
  Loader,
  Message,
  Segment,
} from "semantic-ui-react";
import moment from "moment";
import Swal from "sweetalert2";

import { auth, db } from "../firebase/firebaseConfig";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import IngresoStCabDB from "../firebase/IngresoStCabDB";
import correlativos from "../funciones/correlativosMultiEmpresa";

const fmt = (ts) => (ts?.toDate ? moment(ts.toDate()).format("DD/MM/YYYY HH:mm:ss") : "");

const EquipoRow = ({
  item,
  idx,
  mode,
  toggleEntregaItem,
  toggleRetiroItem,
  setEntregaObs,
  setRetiroObs,
}) => {
  const checked = item.checked === true;

  const esEntrega = mode === "ENTREGA";

  const accent = esEntrega
    ? "#0d9da5"
    : "#f2711c";

  const accentSoft = esEntrega
    ? "#e5f7f7"
    : "#fff3eb";

  return (
    <Segment
      style={{
        padding: 0,
        marginBottom: 12,
        borderRadius: 8,
        overflow: "hidden",
        background: "#ffffff",
        border: checked
          ? `2px solid ${accent}`
          : "1px solid #e5e9ef",
        boxShadow: checked
          ? esEntrega
            ? "0 0 0 3px rgba(13,157,165,0.07)"
            : "0 0 0 3px rgba(242,113,28,0.07)"
          : "0 1px 3px rgba(9,30,66,0.08)",
        transition: "all 0.2s ease",
      }}
    >
      {/* =========================================
                HEADER EQUIPO
            ========================================== */}

      <div
        style={{
          padding: "13px 15px",
          background: checked
            ? accentSoft
            : "#f8fafc",
          borderBottom: "1px solid #e5e9ef",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            minWidth: 0,
            flex: 1,
          }}
        >
          <div
            style={{
              width: 34,
              height: 34,
              minWidth: 34,
              borderRadius: 7,
              background: checked
                ? "#ffffff"
                : accentSoft,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="box"
              style={{
                margin: 0,
                color: accent,
              }}
            />
          </div>

          <div
            style={{
              minWidth: 0,
            }}
          >
            <div
              style={{
                color: "#172b4d",
                fontWeight: 700,
                fontSize: 14,
                lineHeight: 1.25,
              }}
            >
              Equipo {idx + 1}
            </div>

            <div
              style={{
                color: "#6b778c",
                fontSize: 12,
                marginTop: 2,
                overflowWrap: "anywhere",
              }}
            >
              {[item.tipo, item.marca, item.modelo]
                .filter(Boolean)
                .join(" · ")}
            </div>
          </div>
        </div>

        <Form.Checkbox
          toggle
          label={
            esEntrega
              ? "Entregado"
              : "Retirado"
          }
          checked={checked}
          onChange={() =>
            esEntrega
              ? toggleEntregaItem(item.id)
              : toggleRetiroItem(item.id)
          }
        />
      </div>

      {/* =========================================
                INFORMACIÓN
            ========================================== */}

      <div
        style={{
          padding: "13px 15px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(160px, 1fr))",
            gap: 10,
            marginBottom: checked ? 0 : 14,
          }}
        >
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #edf0f4",
              borderRadius: 6,
              padding: "9px 10px",
            }}
          >
            <div
              style={{
                fontSize: 10,
                textTransform: "uppercase",
                letterSpacing: ".4px",
                color: "#98a1af",
                fontWeight: 700,
                marginBottom: 3,
              }}
            >
              Serie
            </div>

            <div
              style={{
                color: "#253858",
                fontWeight: 600,
                fontSize: 13,
                overflowWrap: "anywhere",
              }}
            >
              <Icon
                name="barcode"
                style={{
                  color: "#2185d0",
                }}
              />

              {item.serie || "—"}
            </div>
          </div>

          {item.rfid && (
            <div
              style={{
                background: "#f8fafc",
                border: "1px solid #edf0f4",
                borderRadius: 6,
                padding: "9px 10px",
              }}
            >
              <div
                style={{
                  fontSize: 10,
                  textTransform: "uppercase",
                  letterSpacing: ".4px",
                  color: "#98a1af",
                  fontWeight: 700,
                  marginBottom: 3,
                }}
              >
                RFID
              </div>

              <div
                style={{
                  color: "#253858",
                  fontWeight: 600,
                  fontSize: 13,
                  overflowWrap: "anywhere",
                }}
              >
                <Icon
                  name="wifi"
                  style={{
                    color: "#6435c9",
                  }}
                />

                {item.rfid}
              </div>
            </div>
          )}
        </div>

        {/* OBSERVACIÓN SOLO SI NO SE REALIZÓ */}
        {!checked && (
          <Form>
            <Form.TextArea
              label={
                esEntrega
                  ? "Motivo de no entrega"
                  : "Motivo de no retiro"
              }
              placeholder={
                esEntrega
                  ? "Ej: Cliente no se encontraba, dirección incorrecta..."
                  : "Ej: Equipo no disponible, cliente ausente..."
              }
              value={item.observacion || ""}
              onChange={(e, data) =>
                esEntrega
                  ? setEntregaObs(
                    item.id,
                    data.value
                  )
                  : setRetiroObs(
                    item.id,
                    data.value
                  )
              }
              style={{
                minHeight: 70,
              }}
            />

            <div
              style={{
                marginTop: 5,
                color: "#f2711c",
                fontSize: 11,
              }}
            >
              <Icon name="info circle" />
              La observación es obligatoria si el equipo
              no fue {esEntrega ? "entregado" : "retirado"}.
            </div>
          </Form>
        )}

        {checked && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 7,
              color: accent,
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            <Icon name="check circle" />
            {esEntrega
              ? "Equipo marcado como entregado"
              : "Equipo marcado como retirado"}
          </div>
        )}
      </div>
    </Segment>
  );
};

const Confirmados = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
  const [alerta, cambiarAlerta] = useState({ tipo: "", mensaje: "" });

  const [cabecera, setCabecera] = useState([]);
  const [empresa, setEmpresa] = useState(null);

  // detalle seleccionado
  const [selectedCabId, setSelectedCabId] = useState("");
  const [activePanel, setActivePanel] = useState(null); // "ENTREGA" | "RETIRO" | "TRASPASO"

  // detalles
  const [itemsEntrega, setItemsEntrega] = useState([]);
  const [itemsRetiro, setItemsRetiro] = useState([]);
  const [traspasoE, setTraspasoE] = useState([]);

  const [estadoIngresoST, setEstadoIngresoST] = useState("");

  const cabeceraId = useRef("");
  const inOut = useRef("");

  const empidst = process.env.REACT_APP_EMPID_STINTERNO

  // ---------------- Data Load ----------------
  const loadEmpresa = useCallback(async () => {
    if (!users?.emp_id) return;
    const snap = await getDoc(doc(db, "empresas", users.emp_id));
    setEmpresa(snap.exists() ? snap.data() : null);
  }, [users?.emp_id]);
  console.log(empresa)

  const loadCabeceras = useCallback(async () => {
    if (!users?.emp_id || !users?.correo) return;
    const qCab = query(
      collection(db, "salidasCab"),
      where("emp_id", "==", users.emp_id),
      where("confirmado", "==", true),
      where("correo", "==", users.correo)
    );
    const snap = await getDocs(qCab);
    const arr = snap.docs.map((d, idx) => ({ ...d.data(), id: d.id, id2: idx + 1 }));
    setCabecera(arr);
  }, [users?.emp_id, users?.correo]);

  const loadAll = useCallback(async () => {
    if (!users?.emp_id) return;
    setLoading(true);
    try {
      await Promise.all([loadEmpresa(), loadCabeceras()]);
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudieron cargar los documentos.", "error");
    } finally {
      setLoading(false);
    }
  }, [users?.emp_id, loadEmpresa, loadCabeceras]);

  useEffect(() => {
    loadAll();
  }, [users]);

  // ---------------- Filtrados cabecera ----------------
  const porEntregar = useMemo(
    () =>
      cabecera.filter((c) => {

        // =========================================
        // ENTREGA NORMAL
        // =========================================
        if (c.tipdoc !== "TRASPASOS") {
          return c.entregado === false;
        }

        // =========================================
        // RETORNO ST -> PACIENTE
        // =========================================
        if (
          c.tipdoc === "TRASPASOS" &&
          c.origen_traspaso === "RETORNO_ST_INTERNO"
        ) {
          return (
            c.retirado === true &&
            c.entregado === false
          );
        }

        return false;
      }),
    [cabecera]
  );
  const porRetirar = useMemo(
    () =>
      cabecera.filter(
        (c) => c.retirado === false
      ),
    [cabecera]
  );

  const traspasos = useMemo(
    () =>
      cabecera.filter(
        (c) =>
          c.entregado === false &&
          c.tipdoc === "TRASPASOS" &&
          c.origen_traspaso !== "RETORNO_ST_INTERNO"
      ),
    [cabecera]
  );

  // ==========================================
  // CABECERA SELECCIONADA
  // ==========================================

  const selectedCab = useMemo(() => {
    if (!selectedCabId) return null;

    return (
      cabecera.find(
        (c) => c.id === selectedCabId
      ) || null
    );
  }, [cabecera, selectedCabId]);

  // ==========================================
  // RETORNO DESDE SERVICIO TECNICO
  // ==========================================

  const esRetornoSTSeleccionado =
    selectedCab?.origen_traspaso ===
    "RETORNO_ST_INTERNO";

  // Para retiros normales siempre se permite.
  // Para retorno ST solo cuando la orden
  // ingresostcab está EN RETIRO.
  const puedeConfirmarRetiro =
    !esRetornoSTSeleccionado ||
    estadoIngresoST === "EN RETIRO";

  // ---------------- Load detalles por cabecera ----------------
  const loadDetalleEntrega = useCallback(
    async (cabId) => {
      if (!users?.emp_id || !cabId) return;

      const cab = cabecera.find(
        (c) => c.id === cabId
      );

      if (!cab) return;

      const esRetornoST =
        cab.origen_traspaso ===
        "RETORNO_ST_INTERNO";

      const tipMovEntrega =
        esRetornoST ? 4 : 2;

      const qDet = query(
        collection(db, "salidas"),
        where("emp_id", "==", users.emp_id),
        where("cab_id", "==", cabId),
        where("tipmov", "==", tipMovEntrega)
      );

      const snap = await getDocs(qDet);

      const arr = snap.docs.map(
        (d, idx) => ({
          ...d.data(),
          id: d.id,
          id2: idx + 1,
          checked: false,
          observacion:
            d.data().observacion || "",
        })
      );

      setItemsEntrega(arr);
    },
    [users?.emp_id, cabecera]
  );
  // console.log("itemsEntrega", itemsEntrega)
  const loadDetalleRetiro = useCallback(
    async (cabId) => {
      if (!users?.emp_id || !cabId) return;

      try {
        // Limpiamos estado anterior
        setEstadoIngresoST("");

        // ============================================
        // 1. BUSCAR CABECERA SELECCIONADA
        // ============================================

        const cab = cabecera.find(
          (c) => c.id === cabId
        );

        if (!cab) {
          console.error(
            "No se encontró cabecera:",
            cabId
          );
          return;
        }

        const esRetornoST =
          cab.origen_traspaso ===
          "RETORNO_ST_INTERNO";

        // ============================================
        // 2. CARGAR EQUIPOS
        // ============================================

        // Retiro normal = tipmov 0
        // Retorno ST    = tipmov 4
        const tipMovRetiro =
          esRetornoST ? 4 : 0;

        const qDet = query(
          collection(db, "salidas"),
          where(
            "emp_id",
            "==",
            users.emp_id
          ),
          where(
            "cab_id",
            "==",
            cabId
          ),
          where(
            "tipmov",
            "==",
            tipMovRetiro
          )
        );

        const snap =
          await getDocs(qDet);

        const arr =
          snap.docs.map((d, idx) => ({
            ...d.data(),
            id: d.id,
            id2: idx + 1,
            checked: false,
            observacion:
              d.data().observacion || "",
          }));

        setItemsRetiro(arr);

        // ============================================
        // 3. SI NO ES RETORNO ST TERMINAMOS
        // ============================================

        if (!esRetornoST) {
          return;
        }

        // ============================================
        // 4. VALIDAR ID ORDEN ST
        // ============================================

        if (!cab.id_ingreso_st) {
          console.error(
            "Retorno ST sin id_ingreso_st:",
            cab
          );

          return;
        }

        // ============================================
        // 5. CONSULTAR ORDEN DE INGRESO ST
        // ============================================

        const ingresoRef = doc(
          db,
          "ingresostcab",
          cab.id_ingreso_st
        );

        const ingresoSnap =
          await getDoc(ingresoRef);

        if (!ingresoSnap.exists()) {
          console.error(
            "No existe ingreso ST:",
            cab.id_ingreso_st
          );

          return;
        }

        const ingresoData =
          ingresoSnap.data();

        console.log(
          "Estado orden ST:",
          ingresoData.estado
        );

        // REALIZADO
        // EN RETIRO
        // ENTREGADO
        setEstadoIngresoST(
          ingresoData.estado || ""
        );

      } catch (error) {
        console.error(
          "Error cargando detalle retiro:",
          error
        );

        setItemsRetiro([]);
        setEstadoIngresoST("");
      }
    },
    [users?.emp_id, cabecera]
  );

  const loadDetalleTraspaso = useCallback(
    async (cabId) => {
      if (!users?.emp_id || !cabId) return;

      const qE = query(
        collection(db, "salidas"),
        where("emp_id", "==", users.emp_id),
        where("cab_id", "==", cabId),
        // where("tipmov", "==", 4)
        where("tipmov", "in", [4, 5, 6])
      );
      const snapE = await getDocs(qE);
      setTraspasoE(snapE.docs.map((d, idx) => ({ ...d.data(), id: d.id, id2: idx + 1 })));
    },
    [users?.emp_id]
  );

  const mergeTraspaso = useMemo(() => {
    return traspasoE.toSorted((a, b) => (a.numdoc ?? 0) - (b.numdoc ?? 0));
  }, [traspasoE]);

  const abrirDetalle = async (tipo, cabId) => {
    setSelectedCabId(cabId);
    setActivePanel(tipo);

    try {
      if (tipo === "ENTREGA") await loadDetalleEntrega(cabId);
      if (tipo === "RETIRO") await loadDetalleRetiro(cabId);
      if (tipo === "TRASPASO") await loadDetalleTraspaso(cabId);
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "No se pudieron cargar los movimientos del documento.", "error");
    }
  };

  const cerrarDetalle = () => {
    setActivePanel(null);
    setSelectedCabId("");

    setItemsEntrega([]);
    setItemsRetiro([]);
    setTraspasoE([]);

    // IMPORTANTE
    setEstadoIngresoST("");
  };

  // ---------------- UI helpers ----------------
  const setError = (mensaje) => {
    cambiarEstadoAlerta(true);
    cambiarAlerta({ tipo: "error", mensaje });
  };
  const setOk = (mensaje) => {
    cambiarEstadoAlerta(true);
    cambiarAlerta({ tipo: "exito", mensaje });
  };

  const toggleEntregaItem = (id) => {
    setItemsEntrega((prev) => prev.map((x) => (x.id === id ? { ...x, checked: !x.checked } : x)));
  };
  const setEntregaObs = (id, value) => {
    setItemsEntrega((prev) => prev.map((x) => (x.id === id ? { ...x, observacion: value } : x)));
  };

  const toggleRetiroItem = (id) => {
    setItemsRetiro((prev) => prev.map((x) => (x.id === id ? { ...x, checked: !x.checked } : x)));
  };
  const setRetiroObs = (id, value) => {
    setItemsRetiro((prev) => prev.map((x) => (x.id === id ? { ...x, observacion: value } : x)));
  };

  // ---------------- Core: crear cabecera entrada + batch entradas ----------------
  const CabeceraInDB = async ({
    tipDoc,
    numDoc,
    date,
    tipoInOut,
    rut,
    entidad,
    tipMov,
    confirmado,
    rows,
  }) => {
    // 1) crear cabecera en entradasCab
    const cabDoc = await addDoc(collection(db, "entradasCab"), {
      numdoc: numDoc,
      tipdoc: tipDoc,
      date,
      tipoinout: tipoInOut,
      rut,
      entidad,
      tipmov: tipMov,
      confirmado,
      useradd: user?.email || "",
      usermod: user?.email || "",
      fechaadd: date,
      fechamod: date,
      emp_id: users.emp_id,
    });

    cabeceraId.current = cabDoc.id;

    // 2) crear en entradas
    const batch = writeBatch(db);
    const entradasRef = collection(db, "entradas");

    rows.forEach((docs) => {
      const nuevo = doc(entradasRef);

      batch.set(nuevo, {
        numdoc: docs.numdoc,
        tipdoc: docs.tipdoc,
        date,
        tipoinout: tipoInOut,
        rut: docs.rut,
        entidad: docs.entidad,
        price: 0,
        cab_id: cabDoc.id,
        eq_id: docs.eq_id,
        familia: docs.familia,
        tipo: docs.tipo,
        marca: docs.marca,
        modelo: docs.modelo,
        serie: docs.serie,
        rfid: docs.rfid || "",
        tipmov: 1,
        observacion: docs.observacion || "",
        historial: 0,
        confirmado: false,
        useradd: user?.email || "",
        usermod: user?.email || "",
        fechaadd: date,
        fechamod: date,
        emp_id: users.emp_id,
      });
    });

    await batch.commit();

    return cabDoc.id;
  };

  // ---------------- Confirmar ENTREGA ----------------
  // ---------------- Confirmar ENTREGA ----------------
  const confirmaEntrega = async () => {
    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (!selectedCabId) return;

    const cabActual =
      cabecera.find(
        (c) => c.id === selectedCabId
      ) || null;

    if (!cabActual) {
      setError(
        "No se encontró la cabecera seleccionada."
      );
      return;
    }

    const esRetornoST =
      cabActual.origen_traspaso ===
      "RETORNO_ST_INTERNO";

    const verdaderos =
      itemsEntrega.filter(
        (x) => x.checked === true
      );

    const devolucion =
      itemsEntrega.filter(
        (x) =>
          x.checked === false &&
          String(
            x.observacion || ""
          ).trim() !== ""
      );

    const faltanObs =
      itemsEntrega.filter(
        (x) =>
          x.checked === false &&
          String(
            x.observacion || ""
          ).trim() === ""
      );

    if (faltanObs.length > 0) {
      setError(
        "Debes ingresar observación en los equipos NO entregados."
      );
      return;
    }

    // ==================================================
    // ENTREGA FINAL RETORNO ST
    // ==================================================

    if (esRetornoST) {
      if (verdaderos.length === 0) {
        setError(
          "Debe marcar el equipo como entregado."
        );
        return;
      }

      setSaving(true);

      try {
        const ahora =
          new Date();

        const batch =
          writeBatch(db);

        verdaderos.forEach((d) => {
          // ==========================================
          // EQUIPO NUEVAMENTE EN PACIENTE
          // ==========================================

          batch.update(
            doc(
              db,
              "status",
              d.eq_id
            ),
            {
              status: "PACIENTE",

              r_destino:
                d.rut ||
                cabActual.rut ||
                "",

              n_destino:
                d.entidad ||
                cabActual.entidad ||
                "",

              r_permanente:
                d.rut ||
                cabActual.rut ||
                "",

              n_permanente:
                d.entidad ||
                cabActual.entidad ||
                "",

              fecha_permanente:
                ahora,

              fechamod:
                ahora,
            }
          );

          batch.update(
            doc(
              db,
              "salidas",
              d.id
            ),
            {
              historial: 1,

              fechamod:
                ahora,
            }
          );
        });

        // ==========================================
        // CERRAR RETORNO
        // ==========================================

        batch.update(
          doc(
            db,
            "salidasCab",
            selectedCabId
          ),
          {
            entregado: true,

            usermod:
              user?.email || "",

            fechamod:
              ahora,
          }
        );

        await batch.commit();

        setOk(
          "Entrega confirmada. El equipo quedó nuevamente asignado al paciente."
        );

        await loadCabeceras();
        cerrarDetalle();

        return;

      } catch (error) {
        console.error(
          "Error entrega retorno ST:",
          error
        );

        Swal.fire(
          "Error",
          error?.message ||
          "No fue posible confirmar la entrega.",
          "error"
        );

        return;

      } finally {
        setSaving(false);
      }
    }

    // ==================================================
    // ENTREGA NORMAL
    // ==================================================

    if (
      !empresa?.rut ||
      !empresa?.empresa
    ) {
      Swal.fire(
        "Error",
        "No se encontró configuración de empresa (rut/empresa).",
        "error"
      );

      return;
    }

    setSaving(true);

    try {
      // ==========================================
      // ENTREGADOS
      // ==========================================

      if (verdaderos.length > 0) {
        const destino =
          verdaderos[0].tipoinout;

        const batch =
          writeBatch(db);

        verdaderos.forEach((d) => {
          const st = doc(
            db,
            "status",
            d.eq_id
          );

          if (destino === "PACIENTE") {
            batch.update(st, {
              status: destino,

              r_destino:
                d.rut,

              n_destino:
                d.entidad,

              r_permanente:
                d.rut,

              n_permanente:
                d.entidad,

              fecha_permanente:
                new Date(),

              fechamod:
                new Date(),
            });

          } else if (
            destino ===
            "SERVICIO TECNICO"
          ) {
            batch.update(st, {
              status:
                "SERVICIO TECNICO",

              r_destino:
                d.rut,

              n_destino:
                d.entidad,

              fechamod:
                new Date(),
            });

          } else {
            batch.update(st, {
              status:
                "PROVEEDOR",

              r_destino:
                d.rut,

              n_destino:
                d.entidad,

              fechamod:
                new Date(),
            });
          }
        });

        verdaderos.forEach((d) => {
          batch.update(
            doc(
              db,
              "salidas",
              d.id
            ),
            {
              historial: 1,
            }
          );
        });

        await batch.commit();
      }

      // ==========================================
      // DEVOLUCIONES
      // ==========================================

      if (devolucion.length > 0) {
        const dest =
          devolucion[0].tipoinout;

        if (dest === "PACIENTE") {
          inOut.current =
            "DEVOLUCION PACIENTE";

        } else if (
          dest ===
          "SERVICIO TECNICO"
        ) {
          inOut.current =
            "DEVOLUCION SERVICIO TECNICO";

        } else {
          inOut.current =
            "DEVOLUCION DEL PROVEEDOR";
        }

        await CabeceraInDB({
          emp_id:
            users.emp_id,

          tipDoc:
            devolucion[0].tipdoc,

          numDoc:
            devolucion[0].numdoc,

          date:
            new Date(),

          tipoInOut:
            inOut.current,

          rut:
            devolucion[0].rut,

          entidad:
            devolucion[0].entidad,

          tipMov: 1,

          confirmado: false,

          rows:
            devolucion,
        });

        const batchf =
          writeBatch(db);

        devolucion.forEach((d) => {
          batchf.update(
            doc(
              db,
              "status",
              d.eq_id
            ),
            {
              status:
                "TRANSITO BODEGA",

              r_origen:
                d.rut,

              n_origen:
                d.entidad,

              r_destino:
                empresa.rut,

              n_destino:
                empresa.empresa,

              fechamod:
                new Date(),
            }
          );
        });

        devolucion.forEach((d) => {
          batchf.update(
            doc(
              db,
              "salidas",
              d.id
            ),
            {
              historial: 1,
            }
          );
        });

        await batchf.commit();
      }

      // ==========================================
      // CERRAR CABECERA
      // ==========================================

      await updateDoc(
        doc(
          db,
          "salidasCab",
          selectedCabId
        ),
        {
          entregado: true,

          usermod:
            user?.email || "",

          fechamod:
            new Date(),
        }
      );

      setOk(
        "Entrega confirmada correctamente."
      );

      await loadCabeceras();
      cerrarDetalle();

    } catch (e) {
      console.error(e);

      Swal.fire(
        "Error",
        "No se pudo confirmar la entrega.",
        "error"
      );

    } finally {
      setSaving(false);
    }
  };
  // ---------------- Confirmar RETIRO ----------------
  const confirmaRetiro = async () => {
    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (!selectedCabId) return;

    // ==========================================
    // CABECERA SELECCIONADA
    // ==========================================

    const cabActual =
      cabecera.find(
        (c) => c.id === selectedCabId
      ) || null;

    if (!cabActual) {
      setError(
        "No se encontró la cabecera seleccionada."
      );
      return;
    }

    const esRetornoST =
      cabActual.origen_traspaso ===
      "RETORNO_ST_INTERNO";

    // ==========================================
    // VALIDAR LIBERACION DESDE ST
    // ==========================================

    if (
      esRetornoST &&
      estadoIngresoST !== "EN RETIRO"
    ) {
      setError(
        "Servicio Técnico todavía no ha liberado el equipo para retiro."
      );
      return;
    }

    const verdaderos =
      itemsRetiro.filter(
        (x) => x.checked === true
      );

    const noRetiro =
      itemsRetiro.filter(
        (x) =>
          x.checked === false &&
          String(
            x.observacion || ""
          ).trim() !== ""
      );

    const faltanObs =
      itemsRetiro.filter(
        (x) =>
          x.checked === false &&
          String(
            x.observacion || ""
          ).trim() === ""
      );

    if (faltanObs.length > 0) {
      setError(
        "Debes ingresar observación en los equipos NO retirados."
      );
      return;
    }

    // Para retorno ST debe retirarse el equipo
    if (
      esRetornoST &&
      verdaderos.length === 0
    ) {
      setError(
        "Debe marcar el equipo como retirado."
      );
      return;
    }

    setSaving(true);

    try {
      // ==================================================
      // RETORNO ST -> PACIENTE
      // ==================================================

      if (esRetornoST) {
        const ahora = new Date();

        if (!cabActual.id_ingreso_st) {
          throw new Error(
            "El traspaso no tiene asociada la orden ST."
          );
        }

        const batch =
          writeBatch(db);

        verdaderos.forEach((d) => {
          // ==========================================
          // STATUS DEL EQUIPO
          // ==========================================

          batch.update(
            doc(
              db,
              "status",
              d.eq_id
            ),
            {
              status:
                "TRANSITO PACIENTE",

              // Sale desde Servicio Técnico
              r_origen:
                d.rut_st ||
                cabActual.rutSt ||
                cabActual.rut_st ||
                "",

              n_origen:
                d.nombre_st ||
                cabActual.entidadSt ||
                cabActual.nombre_st ||
                "",

              // Va hacia el paciente
              r_destino:
                d.rut ||
                cabActual.rut ||
                "",

              n_destino:
                d.entidad ||
                cabActual.entidad ||
                "",

              r_permanente: "",
              n_permanente: "",
              fecha_permanente: "",

              fechamod: ahora,
            }
          );

          // ==========================================
          // DETALLE SALIDA
          // ==========================================

          batch.update(
            doc(
              db,
              "salidas",
              d.id
            ),
            {
              observacion:
                d.observacion || "",

              fechamod: ahora,
            }
          );
        });

        // ==========================================
        // CABECERA RETORNO
        // ==========================================

        batch.update(
          doc(
            db,
            "salidasCab",
            selectedCabId
          ),
          {
            retirado: true,

            // todavía falta entrega al paciente
            entregado: false,

            usermod:
              user?.email || "",

            fechamod: ahora,
          }
        );

        // ==========================================
        // ORDEN ST
        // ==========================================

        batch.update(
          doc(
            db,
            "ingresostcab",
            cabActual.id_ingreso_st
          ),
          {
            estado: "ENTREGADO",

            // estado_servicio permanece REALIZADO

            usermod:
              user?.email || "",

            fechamod: ahora,
          }
        );

        await batch.commit();

        setOk(
          "Retiro confirmado. El equipo está en tránsito hacia el paciente."
        );

        await loadCabeceras();
        cerrarDetalle();

        return;
      }

      // ==================================================
      // RETIRO NORMAL
      // ==================================================

      if (
        !empresa?.rut ||
        !empresa?.empresa
      ) {
        Swal.fire(
          "Error",
          "No se encontró configuración de empresa (rut/empresa).",
          "error"
        );

        return;
      }

      // ==========================================
      // NO RETIRADOS
      // ==========================================

      if (noRetiro.length > 0) {
        inOut.current =
          noRetiro[0].tipoinout ===
            "RETIRO PACIENTE"
            ? "PACIENTE"
            : "SERVICIO TECNICO";

        const batch =
          writeBatch(db);

        noRetiro.forEach((d) => {
          batch.update(
            doc(
              db,
              "salidas",
              d.id
            ),
            {
              observacion:
                d.observacion,

              fechamod:
                new Date(),
            }
          );
        });

        noRetiro.forEach((d) => {
          batch.update(
            doc(
              db,
              "status",
              d.eq_id
            ),
            {
              status:
                inOut.current,

              fechamod:
                new Date(),
            }
          );
        });

        await batch.commit();
      }

      // ==========================================
      // RETIRO NORMAL CONFIRMADO
      // ==========================================

      if (verdaderos.length > 0) {
        await CabeceraInDB({
          emp_id:
            users.emp_id,

          tipDoc:
            verdaderos[0].tipdoc,

          numDoc:
            verdaderos[0].numdoc,

          date:
            new Date(),

          tipoInOut:
            verdaderos[0].tipoinout,

          rut:
            verdaderos[0].rut,

          entidad:
            verdaderos[0].entidad,

          tipMov: 1,

          confirmado: false,

          rows:
            verdaderos,
        });

        const batchf =
          writeBatch(db);

        verdaderos.forEach((d) => {
          batchf.update(
            doc(
              db,
              "status",
              d.eq_id
            ),
            {
              status:
                "TRANSITO BODEGA",

              r_origen:
                d.rut,

              n_origen:
                d.entidad,

              r_destino:
                empresa.rut,

              n_destino:
                empresa.empresa,

              r_permanente: "",
              n_permanente: "",
              fecha_permanente: "",

              fechamod:
                new Date(),
            }
          );
        });

        await batchf.commit();
      }

      // ==========================================
      // CABECERA NORMAL
      // ==========================================

      await updateDoc(
        doc(
          db,
          "salidasCab",
          selectedCabId
        ),
        {
          retirado: true,

          usermod:
            user?.email || "",

          fechamod:
            new Date(),
        }
      );

      setOk(
        "Retiro confirmado correctamente."
      );

      await loadCabeceras();
      cerrarDetalle();

    } catch (e) {
      console.error(
        "Error confirmaRetiro:",
        e
      );

      Swal.fire(
        "Error",
        e?.message ||
        "No se pudo confirmar el retiro.",
        "error"
      );

    } finally {
      setSaving(false);
    }
  };
  // ---------------- Obtener o crear cliente ST   ----------------

  const obtenerOCrearClienteST = async () => {
    if (!empresa?.rut || !empresa?.empresa) {
      throw new Error(
        "No se encontraron los datos de la empresa HomeCare."
      );
    }

    if (!empidst) {
      throw new Error(
        "No está configurado el Servicio Técnico interno."
      );
    }

    // BUSCAR HOMECARE COMO CLIENTE DE LOGISTICMED ST
    const qCliente = query(
      collection(db, "clientes"),
      where("emp_id", "==", empidst),
      where("rut", "==", empresa.rut)
    );

    const snapCliente = await getDocs(qCliente);

    // YA EXISTE
    if (!snapCliente.empty) {
      return {
        id: snapCliente.docs[0].id,
        ...snapCliente.docs[0].data(),
      };
    }

    // NO EXISTE -> CREARLO
    const nuevoCliente = {
      rut: empresa.rut,
      nombre: empresa.empresa,

      correo: empresa.correo || "",
      telefono: empresa.telefono || "",
      direccion: empresa.direccion || "",

      activo: true,

      // Pertenece al tenant de Servicio Técnico
      emp_id: empidst,

      // Referencia al HomeCare que originó el cliente
      emp_id_origen: users.emp_id,

      useradd: user?.email || "",
      usermod: user?.email || "",

      fechaadd: new Date(),
      fechamod: new Date(),
    };

    const clienteRef = await addDoc(
      collection(db, "clientes"),
      nuevoCliente
    );

    return {
      id: clienteRef.id,
      ...nuevoCliente,
    };
  };

  // ---------------- Confirmar TRASPASO ----------------
  const confirmaTraspasos = async () => {
    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (!selectedCabId) return;
    if (!mergeTraspaso.length) return;
    setSaving(true);

    try {
      const batch = writeBatch(db);
      const first = mergeTraspaso[0];
      // const statusFinal = first.tipmov === 5 ? "SERVICIO TECNICO" : "PACIENTE";
      const statusFinal = first.tipmov === 5 || first.tipmov === 6 ? "SERVICIO TECNICO" : "PACIENTE";

      // ======================
      // UPDATE STATUS
      // ======================
      mergeTraspaso.forEach((d) => {
        batch.update(doc(db, "status", d.eq_id), {
          status: statusFinal,
          fechamod: new Date(),
        });
      });

      batch.update(doc(db, "salidasCab", selectedCabId), {
        entregado: true,
        usermod: user?.email || "",
        fechamod: new Date(),
      });

      await batch.commit();

      // ======================
      // CREAR INGRESO ST
      // ======================
      // ======================
      // CREAR INGRESO ST
      // ======================
      if (first.tipmov === 6) {

        const clienteData =
          await obtenerOCrearClienteST();

        for (const equipo of mergeTraspaso) {

          // =====================================================
          // 1. VALIDAR TIPO DE ATENCION
          // =====================================================

          const tipoAtencion = String(
            equipo.tipo_atencion || ""
          )
            .trim()
            .toUpperCase();

          if (
            tipoAtencion !== "PREVENTIVA" &&
            tipoAtencion !== "CORRECTIVA"
          ) {
            throw new Error(
              `El equipo ${equipo.serie || ""} no tiene definido el tipo de atención.`
            );
          }

          // =====================================================
          // 2. VALIDAR CORRECTIVA
          // =====================================================

          if (
            tipoAtencion === "CORRECTIVA" &&
            !String(equipo.observacion || "").trim()
          ) {
            throw new Error(
              `El equipo ${equipo.serie || ""} fue marcado como correctivo pero no tiene una falla o síntoma reportado.`
            );
          }

          // =====================================================
          // 3. DETERMINAR SERVICIO ST
          //
          // PREVENTIVA  -> MANTENCION PREVENTIVA
          // CORRECTIVA  -> PRESUPUESTO
          // =====================================================

          const servicioST =
            tipoAtencion === "CORRECTIVA"
              ? "PRESUPUESTO"
              : "MANTENCION PREVENTIVA";

          // =====================================================
          // 4. OBSERVACION QUE RECIBE SERVICIO TECNICO
          // =====================================================

          const observacionST =
            tipoAtencion === "CORRECTIVA"
              ? String(equipo.observacion || "").trim()
              : "";

          // =====================================================
          // 5. ASEGURAR MAESTROS EN ST
          // =====================================================

          await asegurarMaestrosST(equipo);

          // =====================================================
          // 6. NUEVO FOLIO ST
          // =====================================================

          const nuevoFolio = await correlativos(
            empidst,
            "ingresosst"
          );

          // =====================================================
          // 7. CREAR ORDEN DE INGRESO ST
          // =====================================================

          const ingresoRef =
            await IngresoStCabDB({

              folio: nuevoFolio,

              rut:
                clienteData.rut || "",

              entidad:
                clienteData.nombre || "",

              telefono:
                clienteData.telefono || "",

              direccion:
                clienteData.direccion || "",

              correo:
                clienteData.correo || "",

              date: new Date(),

              nacim: "",

              confirmado: false,

              estado:
                "POR CONFIRMAR",

              estado_servicio: "",

              tecnico: "",

              fecha_out: "",

              familia:
                equipo.familia || "",

              tipo:
                equipo.tipo || "",

              marca:
                equipo.marca || "",

              modelo:
                equipo.modelo || "",

              serie:
                equipo.serie || "",

              // =========================================
              // SERVICIO SEGUN TIPO DE ATENCION
              // =========================================

              servicio: servicioST,

              servicionew: "",

              fecha_servicionew: "",

              // =========================================
              // FALLA / SINTOMA REPORTADO POR HOMECARE
              // =========================================

              observaciones:
                observacionST,

              horamaquina: "",

              userAdd:
                user?.email || "",

              userMod:
                user?.email || "",

              fechaAdd:
                new Date(),

              fechaMod:
                new Date(),

              // =========================================
              // LA ORDEN PERTENECE A LOGISTICMED ST
              // =========================================

              emp_id:
                empidst,

              // =========================================
              // TRAZABILIDAD HACIA HOMECARE
              // =========================================

              origen_ingreso:
                "TRASPASO_ST_INTERNO",

              emp_id_origen:
                users.emp_id,

              id_traspaso:
                selectedCabId,

              eq_id_origen:
                equipo.eq_id || "",

              // Preventiva tendrá ID.
              // Correctiva llegará vacío.
              id_mantencion:
                equipo.id_mantencion || "",

              rut_paciente:
                equipo.rut || "",

              paciente:
                equipo.entidad || "",
            });

          // =====================================================
          // 8. MARCAR DETALLE COMO INGRESO ST GENERADO
          // =====================================================

          await updateDoc(
            doc(
              db,
              "salidas",
              equipo.id
            ),
            {
              ingreso_st_generado: true,

              id_ingreso_st:
                ingresoRef.id,

              folio_ingreso_st:
                nuevoFolio,

              fechamod:
                new Date(),
            }
          );
        }
      }

      setOk("Traspaso confirmado correctamente.");
      await loadCabeceras();
      cerrarDetalle();

    } catch (e) {
      console.error(e);
      Swal.fire("Error", e.message, "error");
    } finally {
      setSaving(false);
    }
  };

  // ------------- Helpers asegura maestroST ----------------
  const asegurarMaestrosST = async (equipo) => {
    const ahora = new Date();

    // =========================
    // FAMILIA
    // =========================
    if (equipo?.familia) {
      const qFamilia = query(
        collection(db, "familias"),
        where("emp_id", "==", empidst),
        where("familia", "==", equipo.familia)
      );

      const snapFamilia = await getDocs(qFamilia);

      if (snapFamilia.empty) {
        await addDoc(collection(db, "familias"), {
          activo: true,
          emp_id: empidst,
          familia: equipo.familia,
          fechaadd: ahora,
          fechamod: ahora,
          useradd: user?.email || "",
          usermod: user?.email || "",
        });
      }
    }

    // =========================
    // TIPO
    // =========================
    if (equipo?.familia && equipo?.tipo) {
      const qTipo = query(
        collection(db, "tipos"),
        where("emp_id", "==", empidst),
        where("familia", "==", equipo.familia),
        where("tipo", "==", equipo.tipo)
      );

      const snapTipo = await getDocs(qTipo);

      if (snapTipo.empty) {
        await addDoc(collection(db, "tipos"), {
          activo: true,
          emp_id: empidst,
          familia: equipo.familia,
          tipo: equipo.tipo,
          fechaadd: ahora,
          fechamod: ahora,
          useradd: user?.email || "",
          usermod: user?.email || "",
        });
      }
    }

    // =========================
    // MARCA
    // =========================
    if (equipo?.marca) {
      const qMarca = query(
        collection(db, "marcas"),
        where("emp_id", "==", empidst),
        where("marca", "==", equipo.marca)
      );

      const snapMarca = await getDocs(qMarca);

      if (snapMarca.empty) {
        await addDoc(collection(db, "marcas"), {
          emp_id: empidst,
          marca: equipo.marca,
          fechaadd: ahora,
          fechamod: ahora,
          useradd: user?.email || "",
          usermod: user?.email || "",
        });
      }
    }

    // =========================
    // MODELO
    // =========================
    if (equipo?.marca && equipo?.modelo) {
      const qModelo = query(
        collection(db, "modelos"),
        where("emp_id", "==", empidst),
        where("marca", "==", equipo.marca),
        where("modelo", "==", equipo.modelo)
      );

      const snapModelo = await getDocs(qModelo);

      if (snapModelo.empty) {
        await addDoc(collection(db, "modelos"), {
          emp_id: empidst,
          marca: equipo.marca,
          modelo: equipo.modelo,
          fechaadd: ahora,
          fechamod: ahora,
          useradd: user?.email || "",
          usermod: user?.email || "",
        });
      }
    }
  };

  // ---------------- Render helpers ----------------
  const CabCard = ({ item, tipo }) => {
    const esEntrega = tipo === "ENTREGA";
    const esRetiro = tipo === "RETIRO";

    const accent = esEntrega
      ? "#0d9da5"
      : esRetiro
        ? "#f2711c"
        : "#2185d0";

    const soft = esEntrega
      ? "#e5f7f7"
      : esRetiro
        ? "#fff3eb"
        : "#eaf4fb";

    const icono = esEntrega
      ? "shipping fast"
      : esRetiro
        ? "undo"
        : "exchange";

    const accion = esEntrega
      ? "Revisar entrega"
      : esRetiro
        ? "Revisar retiro"
        : "Revisar traspaso";

    const esRetorno =
      item.origen_traspaso ===
      "RETORNO_ST_INTERNO";

    return (
      <Card
        fluid
        style={{
          width: "100%",
          margin: 0,
          borderRadius: 8,
          border: "1px solid #e5e9ef",
          borderTop: `3px solid ${accent}`,
          boxShadow:
            "0 2px 6px rgba(9,30,66,0.08)",
          overflow: "hidden",
        }}
      >
        <Card.Content
          style={{
            padding: 15,
          }}
        >
          {/* HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 10,
              marginBottom: 13,
            }}
          >
            <div
              style={{
                display: "flex",
                gap: 9,
                minWidth: 0,
                flex: 1,
              }}
            >
              <div
                style={{
                  width: 34,
                  height: 34,
                  minWidth: 34,
                  borderRadius: 7,
                  background: soft,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={icono}
                  style={{
                    margin: 0,
                    color: accent,
                  }}
                />
              </div>

              <div
                style={{
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    color: "#172b4d",
                    fontWeight: 700,
                    fontSize: 15,
                  }}
                >
                  {item.tipdoc} N° {item.numdoc}
                </div>

                <div
                  style={{
                    color: "#8793a5",
                    fontSize: 11,
                    marginTop: 2,
                  }}
                >
                  <Icon
                    name="calendar alternate outline"
                  />
                  {fmt(item.date)}
                </div>
              </div>
            </div>

            <Label
              size="tiny"
              style={{
                margin: 0,
                background: soft,
                border: `1px solid ${accent}33`,
                color: accent,
                whiteSpace: "normal",
                textAlign: "center",
              }}
            >
              {tipo}
            </Label>
          </div>

          {/* TIPO MOVIMIENTO */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 6,
              marginBottom: 13,
            }}
          >
            <Label
              basic
              size="small"
              style={{
                margin: 0,
                color: "#526273",
                borderColor: "#dfe5ec",
                whiteSpace: "normal",
              }}
            >
              <Icon
                name="random"
                style={{
                  color: accent,
                }}
              />
              {item.tipoinout}
            </Label>

            {esRetorno && (
              <Label
                size="small"
                style={{
                  margin: 0,
                  background: "#eaf4fb",
                  color: "#2185d0",
                  border: "1px solid #b8d7f0",
                }}
              >
                <Icon name="exchange" />
                RETORNO S.T.
              </Label>
            )}
          </div>

          {/* CLIENTE */}
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #edf0f4",
              borderRadius: 7,
              padding: "10px 12px",
              display: "grid",
              gap: 7,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 8,
                color: "#344563",
                fontSize: 13,
              }}
            >
              <Icon
                name="user outline"
                style={{
                  color: "#0d9da5",
                  marginTop: 2,
                }}
              />

              <strong
                style={{
                  overflowWrap: "anywhere",
                }}
              >
                {item.entidad || "—"}
              </strong>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#6b778c",
                fontSize: 12,
              }}
            >
              <Icon
                name="id card outline"
                style={{
                  color: "#2185d0",
                }}
              />

              {item.rut || "—"}
            </div>
          </div>
        </Card.Content>

        <Card.Content
          extra
          style={{
            padding: 12,
            background: "#fbfcfd",
            borderTop: "1px solid #edf0f4",
          }}
        >
          <Button
            fluid
            type="button"
            icon
            labelPosition="left"
            onClick={() =>
              abrirDetalle(tipo, item.id)
            }
            style={{
              minHeight: 42,
              background: accent,
              color: "#ffffff",
              borderRadius: 6,
              boxShadow: "none",
            }}
          >
            <Icon name="list" />
            {accion}
          </Button>
        </Card.Content>
      </Card>
    );
  };

  // ---------------- UI ----------------
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        paddingBottom: 40,
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          padding: "20px 16px",
        }}
      >
        {/* =====================================================
                ENCABEZADO
            ====================================================== */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 15,
            flexWrap: "wrap",
            marginBottom: 18,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 13,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                minWidth: 48,
                borderRadius: 10,
                background: "#e5f7f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="truck"
                style={{
                  margin: 0,
                  color: "#0d9da5",
                  fontSize: 21,
                }}
              />
            </div>

            <div>
              <Header
                as="h2"
                style={{
                  margin: 0,
                  color: "#172b4d",
                  fontSize: 22,
                  fontWeight: 700,
                }}
              >
                Gestión de Entregas
              </Header>

              <div
                style={{
                  color: "#8793a5",
                  fontSize: 12,
                  marginTop: 3,
                }}
              >
                Confirme entregas, retiros y traspasos asignados.
              </div>
            </div>
          </div>

          <Button
            type="button"
            basic
            icon
            labelPosition="left"
            onClick={loadAll}
            loading={loading}
            disabled={saving}
            style={{
              borderRadius: 6,
              color: "#0d9da5",
              borderColor: "#b9dfe1",
              background: "#ffffff",
              boxShadow: "none",
            }}
          >
            <Icon name="refresh" />
            Actualizar
          </Button>
        </div>

        {/* =====================================================
                RESUMEN OPERATIVO
            ====================================================== */}

        {activePanel === null && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(180px, 1fr))",
              gap: 12,
              marginBottom: 20,
            }}
          >
            {/* ENTREGA */}
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e5e9ef",
                borderRadius: 8,
                padding: "13px 14px",
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                display: "flex",
                alignItems: "center",
                gap: 11,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  minWidth: 38,
                  borderRadius: 7,
                  background: "#e5f7f7",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="shipping fast"
                  style={{
                    margin: 0,
                    color: "#0d9da5",
                  }}
                />
              </div>

              <div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#8793a5",
                  }}
                >
                  Por entregar
                </div>

                <div
                  style={{
                    color: "#172b4d",
                    fontWeight: 700,
                    fontSize: 21,
                    lineHeight: 1.1,
                  }}
                >
                  {porEntregar.length}
                </div>
              </div>
            </div>

            {/* RETIRO */}
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e5e9ef",
                borderRadius: 8,
                padding: "13px 14px",
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                display: "flex",
                alignItems: "center",
                gap: 11,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  minWidth: 38,
                  borderRadius: 7,
                  background: "#fff3eb",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="undo"
                  style={{
                    margin: 0,
                    color: "#f2711c",
                  }}
                />
              </div>

              <div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#8793a5",
                  }}
                >
                  Por retirar
                </div>

                <div
                  style={{
                    color: "#172b4d",
                    fontWeight: 700,
                    fontSize: 21,
                    lineHeight: 1.1,
                  }}
                >
                  {porRetirar.length}
                </div>
              </div>
            </div>

            {/* TRASPASOS */}
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e5e9ef",
                borderRadius: 8,
                padding: "13px 14px",
                boxShadow:
                  "0 1px 3px rgba(9,30,66,0.06)",
                display: "flex",
                alignItems: "center",
                gap: 11,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  minWidth: 38,
                  borderRadius: 7,
                  background: "#eaf4fb",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="exchange"
                  style={{
                    margin: 0,
                    color: "#2185d0",
                  }}
                />
              </div>

              <div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#8793a5",
                  }}
                >
                  Traspasos
                </div>

                <div
                  style={{
                    color: "#172b4d",
                    fontWeight: 700,
                    fontSize: 21,
                    lineHeight: 1.1,
                  }}
                >
                  {traspasos.length}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* =====================================================
                LOADING
            ====================================================== */}

        {loading ? (
          <Segment
            style={{
              minHeight: 180,
              borderRadius: 8,
              border: "1px solid #e5e9ef",
              boxShadow:
                "0 1px 3px rgba(9,30,66,0.08)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader active inline />

            <div
              style={{
                color: "#6b778c",
                fontSize: 13,
                marginTop: 14,
              }}
            >
              Cargando documentos asignados...
            </div>
          </Segment>
        ) : (
          <>
            {/* =================================================
                        BANDEJA PENDIENTES
                    ================================================== */}

            {activePanel === null && (
              <>
                {/* =========================================
                                ENTREGAS
                            ========================================== */}

                <Segment
                  style={{
                    borderRadius: 8,
                    padding: 0,
                    border: "1px solid #e5e9ef",
                    boxShadow:
                      "0 1px 3px rgba(9,30,66,0.08)",
                    overflow: "hidden",
                    marginBottom: 18,
                  }}
                >
                  <div
                    style={{
                      padding: "13px 16px",
                      borderBottom:
                        "1px solid #edf0f4",
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "#253858",
                        fontWeight: 700,
                      }}
                    >
                      <Icon
                        name="shipping fast"
                        style={{
                          color: "#0d9da5",
                        }}
                      />
                      Entregas pendientes
                    </div>

                    <Label
                      size="small"
                      style={{
                        margin: 0,
                        background: "#e5f7f7",
                        color: "#0d9da5",
                      }}
                    >
                      {porEntregar.length}
                    </Label>
                  </div>

                  <div
                    style={{
                      padding: 14,
                    }}
                  >
                    {porEntregar.length === 0 ? (
                      <Message
                        positive
                        icon
                        style={{
                          margin: 0,
                        }}
                      >
                        <Icon name="check circle" />

                        <Message.Content>
                          <Message.Header>
                            Sin entregas pendientes
                          </Message.Header>

                          No existen documentos
                          pendientes de entrega.
                        </Message.Content>
                      </Message>
                    ) : (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
                          gap: 14,
                        }}
                      >
                        {porEntregar.map((c) => (
                          <CabCard
                            key={c.id}
                            item={c}
                            tipo="ENTREGA"
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </Segment>

                {/* =========================================
                                RETIROS
                            ========================================== */}

                <Segment
                  style={{
                    borderRadius: 8,
                    padding: 0,
                    border: "1px solid #e5e9ef",
                    boxShadow:
                      "0 1px 3px rgba(9,30,66,0.08)",
                    overflow: "hidden",
                    marginBottom: 18,
                  }}
                >
                  <div
                    style={{
                      padding: "13px 16px",
                      borderBottom:
                        "1px solid #edf0f4",
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "#253858",
                        fontWeight: 700,
                      }}
                    >
                      <Icon
                        name="undo"
                        style={{
                          color: "#f2711c",
                        }}
                      />
                      Retiros pendientes
                    </div>

                    <Label
                      size="small"
                      style={{
                        margin: 0,
                        background: "#fff3eb",
                        color: "#f2711c",
                      }}
                    >
                      {porRetirar.length}
                    </Label>
                  </div>

                  <div style={{ padding: 14 }}>
                    {porRetirar.length === 0 ? (
                      <Message
                        positive
                        icon
                        style={{ margin: 0 }}
                      >
                        <Icon name="check circle" />

                        <Message.Content>
                          <Message.Header>
                            Sin retiros pendientes
                          </Message.Header>

                          No existen documentos
                          pendientes de retiro.
                        </Message.Content>
                      </Message>
                    ) : (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
                          gap: 14,
                        }}
                      >
                        {porRetirar.map((c) => (
                          <CabCard
                            key={c.id}
                            item={c}
                            tipo="RETIRO"
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </Segment>

                {/* =========================================
                                TRASPASOS
                            ========================================== */}

                <Segment
                  style={{
                    borderRadius: 8,
                    padding: 0,
                    border: "1px solid #e5e9ef",
                    boxShadow:
                      "0 1px 3px rgba(9,30,66,0.08)",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      padding: "13px 16px",
                      borderBottom:
                        "1px solid #edf0f4",
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        color: "#253858",
                        fontWeight: 700,
                      }}
                    >
                      <Icon
                        name="exchange"
                        style={{
                          color: "#2185d0",
                        }}
                      />
                      Traspasos pendientes
                    </div>

                    <Label
                      size="small"
                      style={{
                        margin: 0,
                        background: "#eaf4fb",
                        color: "#2185d0",
                      }}
                    >
                      {traspasos.length}
                    </Label>
                  </div>

                  <div style={{ padding: 14 }}>
                    {traspasos.length === 0 ? (
                      <Message
                        positive
                        icon
                        style={{ margin: 0 }}
                      >
                        <Icon name="check circle" />

                        <Message.Content>
                          <Message.Header>
                            Sin traspasos pendientes
                          </Message.Header>

                          No existen traspasos
                          pendientes de entrega.
                        </Message.Content>
                      </Message>
                    ) : (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
                          gap: 14,
                        }}
                      >
                        {traspasos.map((c) => (
                          <CabCard
                            key={c.id}
                            item={c}
                            tipo="TRASPASO"
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </Segment>
              </>
            )}

            {/* =================================================
                        DETALLE ENTREGA
                    ================================================== */}

            {activePanel === "ENTREGA" && (
              <Segment
                style={{
                  borderRadius: 8,
                  padding: 0,
                  overflow: "hidden",
                  background: "#ffffff",
                  border: "2px solid #0d9da5",
                  boxShadow:
                    "0 0 0 3px rgba(13,157,165,0.07)",
                }}
              >
                <div
                  style={{
                    padding: "15px 17px",
                    background: "#e5f7f7",
                    borderBottom:
                      "1px solid #bfe8e9",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          color: "#172b4d",
                          fontSize: 18,
                          fontWeight: 700,
                        }}
                      >
                        <Icon
                          name="shipping fast"
                          style={{
                            color: "#0d9da5",
                          }}
                        />
                        Confirmar entrega
                      </div>

                      <div
                        style={{
                          marginTop: 4,
                          color: "#5e6c84",
                          fontSize: 12,
                        }}
                      >
                        Marque los equipos entregados.
                        Si alguno no fue entregado,
                        indique el motivo.
                      </div>
                    </div>

                    <Button
                      type="button"
                      basic
                      icon
                      labelPosition="left"
                      onClick={cerrarDetalle}
                      disabled={saving}
                      style={{
                        background: "#ffffff",
                        color: "#526273",
                      }}
                    >
                      <Icon name="arrow left" />
                      Volver
                    </Button>
                  </div>

                  {selectedCab && (
                    <div
                      style={{
                        marginTop: 12,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 7,
                      }}
                    >
                      <Label basic>
                        {selectedCab.tipdoc} N°{" "}
                        {selectedCab.numdoc}
                      </Label>

                      <Label basic>
                        <Icon name="user outline" />
                        {selectedCab.entidad}
                      </Label>
                    </div>
                  )}
                </div>

                <div style={{ padding: 15 }}>
                  {itemsEntrega.length === 0 ? (
                    <Message warning icon>
                      <Icon name="warning sign" />
                      <Message.Content>
                        <Message.Header>
                          Sin equipos
                        </Message.Header>
                        No hay equipos asociados a este
                        documento.
                      </Message.Content>
                    </Message>
                  ) : (
                    <>
                      {itemsEntrega.map(
                        (it, idx) => (
                          <EquipoRow
                            key={it.id}
                            item={it}
                            idx={idx}
                            mode="ENTREGA"
                            toggleEntregaItem={
                              toggleEntregaItem
                            }
                            toggleRetiroItem={
                              toggleRetiroItem
                            }
                            setEntregaObs={
                              setEntregaObs
                            }
                            setRetiroObs={
                              setRetiroObs
                            }
                          />
                        )
                      )}

                      <Button
                        fluid
                        type="button"
                        size="large"
                        loading={saving}
                        disabled={saving}
                        onClick={confirmaEntrega}
                        style={{
                          marginTop: 8,
                          minHeight: 48,
                          background: "#0d9da5",
                          color: "#ffffff",
                          fontWeight: 700,
                          borderRadius: 7,
                        }}
                      >
                        <Icon name="check" />
                        Confirmar entrega
                      </Button>
                    </>
                  )}
                </div>
              </Segment>
            )}

            {/* =================================================
                        DETALLE RETIRO
                    ================================================== */}

            {activePanel === "RETIRO" && (
              <Segment
                style={{
                  borderRadius: 8,
                  padding: 0,
                  overflow: "hidden",
                  background: "#ffffff",
                  border: "2px solid #f2711c",
                  boxShadow:
                    "0 0 0 3px rgba(242,113,28,0.07)",
                }}
              >
                <div
                  style={{
                    padding: "15px 17px",
                    background: "#fff3eb",
                    borderBottom:
                      "1px solid #f7d6c0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          color: "#172b4d",
                          fontSize: 18,
                          fontWeight: 700,
                        }}
                      >
                        <Icon
                          name="undo"
                          style={{
                            color: "#f2711c",
                          }}
                        />
                        Confirmar retiro
                      </div>

                      <div
                        style={{
                          marginTop: 4,
                          color: "#5e6c84",
                          fontSize: 12,
                        }}
                      >
                        Marque los equipos retirados.
                        Si alguno no fue retirado,
                        indique el motivo.
                      </div>
                    </div>

                    <Button
                      type="button"
                      basic
                      icon
                      labelPosition="left"
                      onClick={cerrarDetalle}
                      disabled={saving}
                      style={{
                        background: "#ffffff",
                        color: "#526273",
                      }}
                    >
                      <Icon name="arrow left" />
                      Volver
                    </Button>
                  </div>

                  {selectedCab && (
                    <div
                      style={{
                        marginTop: 12,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 7,
                      }}
                    >
                      <Label basic>
                        {selectedCab.tipdoc} N°{" "}
                        {selectedCab.numdoc}
                      </Label>

                      <Label basic>
                        <Icon name="user outline" />
                        {selectedCab.entidad}
                      </Label>
                    </div>
                  )}
                </div>

                <div style={{ padding: 15 }}>
                  {/* ESTADO RETORNO ST */}

                  {esRetornoSTSeleccionado &&
                    (estadoIngresoST ===
                      "EN RETIRO" ? (
                      <Message positive icon>
                        <Icon name="check circle" />

                        <Message.Content>
                          <Message.Header>
                            Disponible para retiro
                          </Message.Header>

                          Servicio Técnico liberó el
                          equipo. Puede confirmar su
                          retiro.
                        </Message.Content>
                      </Message>
                    ) : (
                      <Message warning icon>
                        <Icon name="clock outline" />

                        <Message.Content>
                          <Message.Header>
                            Esperando a Servicio
                            Técnico
                          </Message.Header>

                          El equipo todavía no ha
                          sido liberado.

                          {estadoIngresoST && (
                            <>
                              <br />
                              Estado actual:{" "}
                              <strong>
                                {
                                  estadoIngresoST
                                }
                              </strong>
                            </>
                          )}
                        </Message.Content>
                      </Message>
                    ))}

                  {itemsRetiro.length === 0 ? (
                    <Message warning icon>
                      <Icon name="warning sign" />

                      <Message.Content>
                        <Message.Header>
                          Sin equipos
                        </Message.Header>
                        No hay equipos asociados a este
                        documento.
                      </Message.Content>
                    </Message>
                  ) : (
                    <>
                      {itemsRetiro.map(
                        (it, idx) => (
                          <EquipoRow
                            key={it.id}
                            item={it}
                            idx={idx}
                            mode="RETIRO"
                            toggleEntregaItem={
                              toggleEntregaItem
                            }
                            toggleRetiroItem={
                              toggleRetiroItem
                            }
                            setEntregaObs={
                              setEntregaObs
                            }
                            setRetiroObs={
                              setRetiroObs
                            }
                          />
                        )
                      )}

                      <Button
                        fluid
                        type="button"
                        size="large"
                        loading={saving}
                        disabled={
                          saving ||
                          !puedeConfirmarRetiro
                        }
                        onClick={confirmaRetiro}
                        style={{
                          marginTop: 8,
                          minHeight: 48,
                          background:
                            puedeConfirmarRetiro
                              ? "#f2711c"
                              : "#dfe3e8",
                          color:
                            puedeConfirmarRetiro
                              ? "#ffffff"
                              : "#8793a5",
                          fontWeight: 700,
                          borderRadius: 7,
                        }}
                      >
                        <Icon
                          name={
                            puedeConfirmarRetiro
                              ? "check"
                              : "lock"
                          }
                        />

                        {esRetornoSTSeleccionado &&
                          !puedeConfirmarRetiro
                          ? "Esperando entrega desde S.T."
                          : "Confirmar retiro"}
                      </Button>
                    </>
                  )}
                </div>
              </Segment>
            )}

            {/* =================================================
                        DETALLE TRASPASO
                    ================================================== */}

            {activePanel === "TRASPASO" && (
              <Segment
                style={{
                  borderRadius: 8,
                  padding: 0,
                  overflow: "hidden",
                  background: "#ffffff",
                  border: "2px solid #2185d0",
                  boxShadow:
                    "0 0 0 3px rgba(33,133,208,0.07)",
                }}
              >
                <div
                  style={{
                    padding: "15px 17px",
                    background: "#eaf4fb",
                    borderBottom:
                      "1px solid #c8e0f2",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        "space-between",
                      alignItems: "center",
                      gap: 10,
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          color: "#172b4d",
                          fontSize: 18,
                          fontWeight: 700,
                        }}
                      >
                        <Icon
                          name="exchange"
                          style={{
                            color: "#2185d0",
                          }}
                        />
                        Confirmar traspaso
                      </div>

                      <div
                        style={{
                          marginTop: 4,
                          color: "#5e6c84",
                          fontSize: 12,
                        }}
                      >
                        Revise los equipos antes de
                        confirmar el traspaso.
                      </div>
                    </div>

                    <Button
                      basic
                      type="button"
                      icon
                      labelPosition="left"
                      onClick={cerrarDetalle}
                      disabled={saving}
                      style={{
                        background: "#ffffff",
                        color: "#526273",
                      }}
                    >
                      <Icon name="arrow left" />
                      Volver
                    </Button>
                  </div>

                  {selectedCab && (
                    <div
                      style={{
                        marginTop: 12,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 7,
                      }}
                    >
                      <Label basic>
                        {selectedCab.tipdoc} N°{" "}
                        {selectedCab.numdoc}
                      </Label>

                      <Label basic>
                        <Icon name="user outline" />
                        {selectedCab.entidad}
                      </Label>
                    </div>
                  )}
                </div>

                <div style={{ padding: 15 }}>
                  {mergeTraspaso.length === 0 ? (
                    <Message warning icon>
                      <Icon name="warning sign" />

                      <Message.Content>
                        <Message.Header>
                          Sin movimientos
                        </Message.Header>

                        No hay equipos asociados a este
                        traspaso.
                      </Message.Content>
                    </Message>
                  ) : (
                    <>
                      {mergeTraspaso.map((it, idx) => {
                        const tipoAtencion = String(
                          it.tipo_atencion || ""
                        )
                          .trim()
                          .toUpperCase();

                        const esPreventiva =
                          tipoAtencion === "PREVENTIVA";

                        const esCorrectiva =
                          tipoAtencion === "CORRECTIVA";

                        return (
                          <div
                            key={it.id ?? idx}
                            style={{
                              background: "#ffffff",
                              border: esCorrectiva
                                ? "1px solid #f3c38f"
                                : esPreventiva
                                  ? "1px solid #9fdfe5"
                                  : "1px solid #e5e9ef",
                              borderRadius: 7,
                              padding: "12px 13px",
                              marginBottom: 10,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent:
                                  "space-between",
                                alignItems: "center",
                                gap: 10,
                                flexWrap: "wrap",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    color: "#172b4d",
                                    fontWeight: 700,
                                    fontSize: 13,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <span>
                                    Equipo {idx + 1}
                                  </span>

                                  {tipoAtencion && (
                                    <Label
                                      size="tiny"
                                      style={{
                                        margin: 0,
                                        background:
                                          esCorrectiva
                                            ? "#f2711c"
                                            : esPreventiva
                                              ? "#00b5ad"
                                              : "#767676",
                                        color: "#ffffff",
                                        fontWeight: 700,
                                      }}
                                    >
                                      <Icon
                                        name={
                                          esCorrectiva
                                            ? "wrench"
                                            : esPreventiva
                                              ? "calendar check"
                                              : "info circle"
                                        }
                                      />

                                      {tipoAtencion}
                                    </Label>
                                  )}
                                </div>

                                <div
                                  style={{
                                    marginTop: 4,
                                    color: "#6b778c",
                                    fontSize: 12,
                                  }}
                                >
                                  {[
                                    it.tipo,
                                    it.marca,
                                    it.modelo,
                                  ]
                                    .filter(Boolean)
                                    .join(" · ")}
                                </div>
                              </div>

                              <Label
                                basic
                                style={{
                                  margin: 0,
                                }}
                              >
                                <Icon name="barcode" />
                                {it.serie || "—"}
                              </Label>
                            </div>

                            {esCorrectiva &&
                              String(
                                it.observacion || ""
                              ).trim() && (
                                <div
                                  style={{
                                    marginTop: 10,
                                    padding: "9px 11px",
                                    background:
                                      "#fff8f2",
                                    borderLeft:
                                      "3px solid #f2711c",
                                    borderRadius: 5,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems:
                                        "center",
                                      gap: 6,
                                      color: "#b85c00",
                                      fontWeight: 700,
                                      fontSize: 12,
                                      marginBottom: 3,
                                    }}
                                  >
                                    <Icon name="warning circle" />
                                    Falla o síntoma reportado
                                  </div>

                                  <div
                                    style={{
                                      color: "#5e6c84",
                                      fontSize: 12,
                                      lineHeight: 1.45,
                                    }}
                                  >
                                    {it.observacion}
                                  </div>
                                </div>
                              )}
                          </div>
                        );
                      })}

                      <Button
                        fluid
                        type="button"
                        size="large"
                        loading={saving}
                        disabled={saving}
                        onClick={
                          confirmaTraspasos
                        }
                        style={{
                          marginTop: 8,
                          minHeight: 48,
                          background: "#2185d0",
                          color: "#ffffff",
                          fontWeight: 700,
                          borderRadius: 7,
                        }}
                      >
                        <Icon name="check" />
                        Confirmar traspaso
                      </Button>
                    </>
                  )}
                </div>
              </Segment>
            )}
          </>
        )}

        {/* =====================================================
                ALERTA
            ====================================================== */}

        {estadoAlerta && (
          <Message
            style={{
              marginTop: 14,
              borderRadius: 7,
            }}
            positive={alerta.tipo === "exito"}
            negative={alerta.tipo === "error"}
            icon
          >
            <Icon
              name={
                alerta.tipo === "exito"
                  ? "check circle"
                  : "exclamation triangle"
              }
            />

            <Message.Content>
              <Message.Header>
                {alerta.tipo === "exito"
                  ? "Operación realizada"
                  : "Atención"}
              </Message.Header>

              {alerta.mensaje}
            </Message.Content>
          </Message>
        )}
      </Container>
    </div>
  );
}

export default Confirmados;